import { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import { useId } from "react";
import { useDispatch } from "react-redux";
import { changeStringValue } from "../../../../store/model";

interface TextInputProp {
  properyItem: GeometricShape,
  propertyName: string,
  properyDisplayName: string,
  injection?: ActionCreatorWithPayload<{
    id: string;
    propertyValue: string;
    propertyName: string;
  }>,
}
const TextInput = ({ properyItem, propertyName, properyDisplayName, injection }: TextInputProp) => {


  const dispatch = useDispatch();
  const inputID = useId();

  function value() {
    if (hasKey(properyItem, propertyName)) {
      return properyItem[propertyName] as string;
    }
  }

  const onChangeFunction = injection ?
    (text: string) => injection({ id: properyItem.type, propertyValue: text, propertyName: propertyName }) :
    (text: string) => changeStringValue({ id: properyItem.id, propertyValue: text, propertyName: propertyName });


  return (
    <>
      <label htmlFor={inputID} className='element__part__name'>
        {properyDisplayName}
      </label>
      <textarea
        id={inputID}
        value={value() ?? ''}
        rows={2}
        onChange={e => {
          const text = e.target.value || "";
          dispatch(onChangeFunction(text));
        }}
      />
    </>
  )
}

function hasKey<O extends GeometricShape>(obj: O, key: PropertyKey): key is keyof O {
  return key in obj
}

export default TextInput